import { get } from 'lodash';
import { isDelivery } from "./address";
import { isAddressSelected } from "../reducers/addressReducer";
import {TICKET_TYPE} from '../const/ticket_type';
import {getSelectedCustomerType, isStrictMedicalCustomerType} from "./customer_type_selector";
import {isSalesChannelNameProvided} from './configSelectors';
import {CUSTOMER_TYPE} from "../const/query_params";

export const getSalesChannelName = state => get(state, 'salesChannel.name', undefined);

export const getFulfillmentTypes = state => {
    if (isAddressSelected(state)) {
        if (isDelivery(state)) {
            return TICKET_TYPE.DELIVERY;
        }
        return TICKET_TYPE.PICKUP;
    }
    return undefined;
};

export const getMenuQueryParameter = (state, specificCustomerType) => {
  const queryParamList = [];

  const salesChannelName = getSalesChannelName(state);
  if (salesChannelName) {
    queryParamList.push(`salesChannelName=${salesChannelName}`);
  }

  if (!isSalesChannelNameProvided(state)) {
    const fulfillmentType = getFulfillmentTypes(state);
    if (fulfillmentType) {
      queryParamList.push(`fulfillmentTypes=${fulfillmentType}`);
    }
  }

  if (specificCustomerType) {
    queryParamList.push(`${CUSTOMER_TYPE}=${specificCustomerType}`);
  } else {
    const selectedCustomerType = getSelectedCustomerType(state) || state.router.location.query[CUSTOMER_TYPE];
    if (selectedCustomerType) {
      queryParamList.push(`${CUSTOMER_TYPE}=${selectedCustomerType}`);
    }
  }
  
  const strictMedicalCustomerType = isStrictMedicalCustomerType(state);
  queryParamList.push(`strictMedicalCustomerType=${strictMedicalCustomerType}`);

  return queryParamList.join("&");
};



// WEBPACK FOOTER //
// ./src/selectors/sales_channel_selectors.js